import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";

// Import global CSS for web (Tailwind)
import "./global.css";

// Load custom fonts for web
import { loadWebFonts } from "./src/web/WebFontLoader";
loadWebFonts();

const container = document.getElementById("root");
if (!container) throw new Error("Root container missing in index.html");

const root = createRoot(container);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);